/* eslint-disable react/prop-types */

/* eslint-disable prettier/prettier */
import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.619 2.38095H8.90475V4.7619H6.5238V2.38095C6.5238 1.06599 7.58979 0 8.90475 0H19.619C20.934 0 22 1.06599 22 2.38095V16.6667C22 17.9816 20.934 19.0476 19.619 19.0476H17.2381V16.6667H19.619V2.38095ZM2.95249 8.33333H13.6668V22.619H2.95249L2.95249 8.33333ZM0.571533 8.33333C0.571533 7.01837 1.63752 5.95238 2.95249 5.95238H13.6668C14.9817 5.95238 16.0477 7.01837 16.0477 8.33333V22.619C16.0477 23.934 14.9817 25 13.6668 25H2.95249C1.63752 25 0.571533 23.934 0.571533 22.619V8.33333Z"
}), 'Copy', {
  viewBox: '0 0 22 25'
});